"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringUtils = void 0;
const is_base64_1 = __importDefault(require("is-base64"));
var StringUtils;
(function (StringUtils) {
    function replaceLineBreaks(input) {
        if (!input) {
            return input;
        }
        return input.replace(/\\n/g, "\n");
    }
    StringUtils.replaceLineBreaks = replaceLineBreaks;
    function isBase64Valid(test) {
        return (0, is_base64_1.default)(test, { paddingRequired: false });
    }
    StringUtils.isBase64Valid = isBase64Valid;
    function isInRegExpList(regExpList, value) {
        var _a;
        for (const regExpItem of regExpList) {
            const regExp = new RegExp(regExpItem);
            if (((_a = value.match(regExp)) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                return true;
            }
        }
        return false;
    }
    StringUtils.isInRegExpList = isInRegExpList;
})(StringUtils || (exports.StringUtils = StringUtils = {}));
//# sourceMappingURL=StringUtils.js.map